import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { bookPropertyRoom } from '../../../../api/user/property/property';
import Payment from '../../../payments/Payment';
import Notification from '@spotfli/ui/Notification';
import styles from './css/RentBookingForm.module.css';

const RentBookingForm = ({ propertyId, room, onClose }) => {
    const [formData, setFormData] = useState({
        checkInMonth: '',
        number: '',
        specialRequests: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isModal, setIsModal] = useState(false);
    const [message, setMessage] = useState('');
    const navigate = useNavigate();

    // Check if apartment is available
    const isApartmentAvailable = room && room.quantityAvailable > 0;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (number, medium, type) => {
        if (!isApartmentAvailable) return;

        setLoading(true);
        setError(null);

        try {
            const response = await bookPropertyRoom(propertyId, room._id, formData, number, medium, type);

            if (response.success) {
                navigate('/user/bookings', {
                    state: {
                        bookingSuccess: true,
                    }
                });
                setMessage(response.message);
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];

    return (
        <>
            {isModal && isApartmentAvailable && (
                <Payment
                    onClose={() => setIsModal(false)}
                    handleSubmit={handleSubmit}
                    amounts={1000}
                // hotel={false}
                />
            )}

            {message && (
                <Notification
                    message={message}
                    noMessage={() => setMessage('')}
                />
            )}

            <div className={styles.bookingFormContainer}>
                <div className={styles.formHeader}>
                    {onClose && (
                        <button onClick={onClose} className={styles.closeButton} aria-label="Close">
                            <i className={`fa fa-times ${styles.closeIcon}`} />
                        </button>
                    )}
                    <div className={styles.roomHeader}>
                        <h3 className={styles.roomType}>Book {room.roomType || 'Apartment'}</h3>
                        <div className={styles.priceDisplay}>
                            <span className={styles.priceAmount}>XAF 1000</span> <br />
                            <span className={styles.pricePeriod}>Booking fee to get in contact to landlord</span>
                        </div>
                    </div>
                    <div className={styles.yearlyPrice}>
                        <span className={styles.yearlyLabel}>Monthly Rent:</span>
                        <span className={styles.yearlyAmount}>XAF {(room.price)?.toLocaleString() || '0'}</span>
                    </div>

                    <div className={styles.platformFeeNote}>
                        <span className={styles.platformFeeIcon}><i className="fa fa-info-circle" /></span>
                        <span>You will be charged 1000 FCFA as Platform Charges after completing your booking. You will then be given access to contact the landlord directly after payment is completed.</span>
                    </div>

                </div>

                {isApartmentAvailable ? (
                    <form className={styles.bookingForm}>
                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}>
                                <span className={styles.labelIcon}><i className="fa fa-calendar" /></span>
                                Check-in Month
                            </label>
                            <select
                                name="checkInMonth"
                                value={formData.checkInMonth}
                                onChange={handleChange}
                                required
                                className={styles.formSelect}
                            >
                                <option value="">Select Month</option>
                                {months.map(month => (
                                    <option key={month} value={month}>
                                        {month}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}>
                                <span className={styles.labelIcon}><i className="fa fa-users" /></span>
                                Number of People
                            </label>
                            <input
                                type="number"
                                name="number"
                                value={formData.number}
                                onChange={handleChange}
                                required
                                min="1"
                                max="10"
                                className={styles.formInput}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label className={styles.formLabel}>
                                <span className={styles.labelIcon}><i className="fa fa-comment" /></span>
                                Special Requests
                            </label>
                            <textarea
                                name="specialRequests"
                                value={formData.specialRequests}
                                onChange={handleChange}
                                rows="3"
                                placeholder="Any special requirements or preferences?"
                                className={styles.formTextarea}
                            />
                        </div>

                        <div className={styles.priceSummary}>
                            <div className={styles.summaryHeader}>
                                <h4 className={styles.summaryTitle}>Booking Summary</h4>
                            </div>
                            <div className={styles.summaryItems}>
                                <div className={styles.summaryItem}>
                                    <span className={styles.itemLabel}>Booking Fee</span>
                                    <span className={styles.itemValue}>XAF 1000</span>
                                </div>
                                {/* <div className={styles.summaryItem}>
                                    <span className={styles.itemLabel}>Period</span>
                                    <span className={styles.itemValue}>Monthly</span>
                                </div> */}
                                {formData.checkInMonth && (
                                    <div className={styles.summaryItem}>
                                        <span className={styles.itemLabel}>Check-in</span>
                                        <span className={styles.itemValue}>{formData.checkInMonth}</span>
                                    </div>
                                )}
                            </div>
                        </div>

                        {error && (
                            <div className={styles.errorMessage}>
                                <i className={`fa fa-exclamation-triangle ${styles.errorIcon}`} />
                                {error}
                            </div>
                        )}

                        <button
                            type="button"
                            className={styles.bookButton}
                            disabled={loading || !formData.number || !formData.checkInMonth}
                            onClick={(e) => {
                                e.preventDefault();
                                // setIsModal(true);
                                handleSubmit(formData.number, 'none', 'booking');
                            }}
                        >
                            {loading ? (
                                <>
                                    <span className={styles.loadingSpinner}></span>
                                    Processing...
                                </>
                            ) : (
                                <>
                                    <span className={styles.buttonIcon}><i className="fa fa-key" /></span>
                                    Book Now
                                    <i className={`fa fa-arrow-right ${styles.buttonArrow}`} />
                                </>
                            )}
                        </button>
                    </form>
                ) : (
                    <div className={styles.unavailableContainer}>
                        <div className={styles.unavailableIcon}><i className="fa fa-ban" /></div>
                        <h4 className={styles.unavailableTitle}>Apartment Unavailable</h4>
                        <p className={styles.unavailableMessage}>
                            No apartments in this category are available at the moment.
                            <br />
                            Please select another apartment type.
                        </p>
                        <div className={styles.availabilityInfo}>
                            <div className={styles.availabilityItem}>
                                <span className={styles.availabilityLabel}>Currently Available:</span>
                                <span className={styles.availabilityValue}>{room.quantityAvailable || 0}</span>
                            </div>
                        </div>
                        {onClose && (
                            <button
                                className={styles.selectAnotherButton}
                                onClick={onClose}
                            >
                                <span className={styles.buttonIcon}><i className="fa fa-arrow-left" /></span>
                                Select Another Apartment
                            </button>
                        )}
                    </div>
                )}

                <div className={styles.formFooter}>
                    <p className={styles.footerText}>
                        <span className={styles.footerIcon}><i className="fa fa-lock" /></span>
                        Secure booking • Free cancellation • Best price guaranteed
                    </p>
                </div>
            </div>
        </>
    );
};

export default RentBookingForm;